// extracted by mini-css-extract-plugin
export default {"swiper":"ProjectsSlider_swiper__8Bfh4","swiperSlide":"ProjectsSlider_swiperSlide__LZc+g"};